module.exports = __webpack_public_path__ + "img/private_event_dancing.7cd4f2a0.jpg";